import React, { useState } from 'react';

const Results = ({ scores, maxScore }) => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sendStatus, setSendStatus] = useState(null);
  const [showEmailForm, setShowEmailForm] = useState(false); 
  const [countryCode, setCountryCode] = useState('');
  const [whatsapp, setWhatsapp] = useState('');

  const personalityScores = {
    8: scores.G || 0,
    9: scores.A || 0,
	1: scores.D || 0,
    2: scores.F || 0,
    3: scores.C || 0,
    4: scores.E || 0,
    5: scores.H || 0,
    6: scores.B || 0,
    7: scores.I || 0    
  };

  const getTriadScores = () => {
    const visceral = (scores.G || 0) + (scores.A || 0) + (scores.D || 0);
    const emocional = (scores.F || 0) + (scores.C || 0) + (scores.E || 0);
    const mental = (scores.H || 0) + (scores.B || 0) + (scores.I || 0);
    return { visceral, emocional, mental };
  };

  const triadScores = getTriadScores();
  
  

  const getEneagramType = () => {
    const maxScoreType = Object.entries(personalityScores).reduce((a, b) => (b[1] > a[1] ? b : a));
    return maxScoreType[0]; 
  };

  const eneagramType = getEneagramType();

  const getEneagramMessage = (type) => {
    switch (type) {
      case '1':
  return `
    <div>
      <!-- Título -->
      <h1 class="text-[32px] font-bold font-serif text-[#00273C] text-center mb-6">
        ¡El eneatipo que mejor te describe es el eneatipo 1: El Perfeccionista!
      </h1>

      <!-- Subtítulo -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        Estas son algunas de sus conductas:
      </h2>

      <!-- Lista de conductas -->
      <ul class="list-disc pl-6 text-[16px] text-[#333333] leading-relaxed mb-6">
        <li>El Eneatipo 1 es como esa persona que no puede ignorar un cuadro torcido en la pared. 🖼️📏</li>
        <li>Se mueve al ritmo de altos estándares, un sentido del deber que ni los superhéroes tienen. 📑✔️</li>
        <li>Es el rey/reina de las listas: si no está anotado, no existe. 📝💡</li>
        <li>Tiene una brújula moral interna: todo debe ir en la dirección correcta. 🧭⚖️</li>
        <li>Vivir con una voz crítica interna a tiempo completo puede ser agotador. 😅</li>
      </ul>

      <!-- Subtítulo adicional -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        ¿Te suena esto familiar?
      </h2>

      <!-- Preguntas adicionales -->
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Te encuentras tan ocupado(a) corrigiendo todo que apenas tienes tiempo para disfrutar? 🏖️
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Sientes que ese impulso por hacerlo perfecto está drenando tu energía (y tu paciencia)? 🪫
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Estás cansado(a) de querer controlarlo todo, mientras el caos toca a la puerta? 🚪😅
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-6">
        El autoconocimiento no solo te libera de estos bloqueos, sino que también te ayuda a encontrar equilibrio y enfoque para vivir mejor. 🌟
      </p>

      <!-- Cierre -->
      <p class="text-[16px] text-[#333333] leading-relaxed">
        Suscríbete ahora y recibe más información sobre tu eneatipo, junto con un par de estrategias claras y prácticas para convertir tus descubrimientos 
        en herramientas de crecimiento personal. Porque transformar tu vida empieza con un solo paso... ¡éste! 🚀
      </p>
    </div>
  `;
      case '2':
  return `
    <div>
      <!-- Título -->
      <h1 class="text-[32px] font-bold font-serif text-[#00273C] text-center mb-6">
        ¡El eneatipo que mejor te describe es el Eneatipo 2: El Ayudador!
      </h1>

      <!-- Subtítulo -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        Estas son algunas de sus conductas:
      </h2>

      <!-- Lista de conductas -->
      <ul class="list-disc pl-6 text-[16px] text-[#333333] leading-relaxed mb-6">
        <li>Este eneatipo se distingue por anticipar las necesidades de los demás, ofreciendo apoyo incluso antes de que sea solicitado. Es como quien aparece con sopa sin que nadie lo pida. 🍲💕</li>
        <li>Tiene un instinto para detectar lo que otros necesitan, aunque a menudo pasa por alto sus propias necesidades. 🙃</li>
        <li>Se preocupa profundamente por los demás, recordando detalles importantes como fechas especiales o gestos que hacen sentir valoradas a las personas. 🎂🐾</li>
        <li>El deseo de ser útil puede convertirse en una carga, especialmente cuando no recibe el mismo nivel de atención o cuidado que ofrece. 😓Es muy empático y puede leer las emociones de los demás fácilmente. 👀💞</li>
        <li>Sin embargo, en su esencia, este eneatipo brilla por su capacidad de conectar desde el amor, la empatía y una generosidad auténtica. 🌟💞Puede ser muy persuasivo para conseguir lo que quiere. 🗣️✨</li>
      </ul>

      <!-- Subtítulo adicional -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        ¿Te suena esto familiar?
      </h2>

      <!-- Preguntas adicionales -->
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Te cuesta priorizar tus propias necesidades sobre las de los demás? 🛑
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Alguna vez has sentido que tu valor está ligado a cuánto haces por otros? 🪙
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Te preguntas por qué nadie parece notar cuánto esfuerzo pones para ayudar? 🤔
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-6">
        El autoconocimiento puede ayudarte a encontrar un equilibrio, reconociendo el valor de cuidar tanto de los demás como de ti mismo(a). 🌱
      </p>

      <!-- Cierre -->
      <p class="text-[16px] text-[#333333] leading-relaxed">
        Suscríbete ahora y recibe más información sobre el Eneatipo 2, junto con un par de estrategias claras y prácticas para convertir sus características 
        en herramientas de crecimiento personal. Porque transformar tu vida empieza con un solo paso... ¡éste! 🚀
      </p>
    </div>
  `;
	case '3':
  return `
    <div>
      <!-- Título -->
      <h1 class="text-[32px] font-bold font-serif text-[#00273C] text-center mb-6">
        ¡El eneatipo que mejor te describe es el Eneatipo 3: El Triunfador!
      </h1>

      <!-- Subtítulo -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        Estas son algunas de sus conductas:
      </h2>

      <!-- Lista de conductas -->
      <ul class="list-disc pl-6 text-[16px] text-[#333333] leading-relaxed mb-6">
        <li>Este eneatipo es como esa persona que tiene una lista de tareas para su lista de tareas. 📝📋 Siempre en movimiento, buscando cómo lograr más en menos tiempo. ⏱️</li>
        <li>Tiene un talento natural para brillar en cualquier situación, incluso en esa reunión que podría haber sido un correo electrónico. 💡✨</li>
        <li>Valora profundamente el reconocimiento, tanto que probablemente tenga un lugar especial para todos sus trofeos (incluyendo aquel por "Mejor sonrisa" en primaria). 🏆😄</li>
        <li>Su lema podría ser: "Descansaré cuando logre mis metas... es decir, nunca." 😅</li>
        <li>En su mejor versión, lidera con autenticidad y motiva a otros a alcanzar su máximo potencial, sin necesidad de usar corbata todos los días. 🌟🙌</li>
      </ul>

      <!-- Subtítulo adicional -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        ¿Te suena esto familiar?
      </h2>

      <!-- Preguntas adicionales -->
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Sientes que siempre debes ser el número uno, incluso en competencias de comer pizza? 🍕
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Te cuesta disfrutar el momento porque ya estás pensando en tu próximo gran proyecto (o en cómo conquistar el mundo)? 🌍💭
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Has notado que tu sentido de valía a veces se mide en "likes" o aplausos? 👏❤️
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-6">
        El autoconocimiento puede ayudarte a encontrar un equilibrio, permitiéndote alcanzar tus metas sin perder de vista lo que realmente importa (como esa serie que dejaste a medias). 🌱
      </p>

      <!-- Cierre -->
      <p class="text-[16px] text-[#333333] leading-relaxed">
        Suscríbete ahora y recibe más información sobre el Eneatipo 3, junto con estrategias claras y prácticas para convertir tus características en herramientas de crecimiento personal. 
        Porque transformar tu vida empieza con un solo paso... ¡éste! 🚀
      </p>
    </div>
  `;
	 case '4':
  return `
    <div>
      <!-- Título -->
      <h1 class="text-[32px] font-bold font-serif text-[#00273C] text-center mb-6">
        ¡El eneatipo que mejor se refleja en ti es el Eneatipo 4: El Especial!
      </h1>

      <!-- Subtítulo -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        Estas son algunas de sus conductas:
      </h2>

      <!-- Lista de conductas -->
      <ul class="list-disc pl-6 text-[16px] text-[#333333] leading-relaxed mb-6">
        <li>Este eneatipo es como ese artista que ve un atardecer y dice: "Esto me representa". 🎨🌅</li>
        <li>Busca ser auténtico y único en todo lo que hace, lo que puede llevarlo a ser un poco dramático en sus expresiones. ¿Drama yo? ¡Jamás! 🎭✨</li>
        <li>Tiene una conexión intensa con sus emociones, navegando por olas de melancolía y momentos de inspiración. 🌊</li>
        <li>A menudo se compara con los demás, como si participara en una competencia invisible de "¿quién tiene la vida más interesante?". 🪞</li>
        <li>En su mejor versión, es un faro de creatividad, autenticidad y empatía, inspirando a quienes lo rodean con su perspectiva única. 🌟💖</li>
      </ul>

      <!-- Subtítulo adicional -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        ¿Te suena esto familiar?
      </h2>

      <!-- Preguntas adicionales -->
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Sientes que el mundo no te entiende y necesitas poner música triste para procesarlo? 🎶😢
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿A veces sientes que algo increíble te falta, aunque no sepas exactamente qué es? 💭
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Las emociones intensas a veces te llevan a pensar: "Soy un caso especial, nadie me comprende"? 🤔
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-6">
        El autoconocimiento puede ayudarte a encontrar equilibrio, transformando tus emociones en un motor para vivir con más autenticidad y creatividad. 🌱
      </p>

      <!-- Cierre -->
      <p class="text-[16px] text-[#333333] leading-relaxed">
        Suscríbete ahora y recibe más información sobre el Eneatipo 4, junto con estrategias claras y prácticas para convertir sus características en herramientas 
        de crecimiento personal. Porque transformar tu vida empieza con un solo paso... ¡éste! 🚀
      </p>
    </div>
  `;	
	  case '5':
  return `
    <div>
      <!-- Título -->
      <h1 class="text-[32px] font-bold font-serif text-[#00273C] text-center mb-6">
        ¡El eneatipo que mejor se refleja en ti es el Eneatipo 5: El Observador!
      </h1>

      <!-- Subtítulo -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        Estas son algunas de sus conductas:
      </h2>

      <!-- Lista de conductas -->
      <ul class="list-disc pl-6 text-[16px] text-[#333333] leading-relaxed mb-6">
        <li>Este eneatipo siempre está absorbiendo información, como si fuera una esponja para datos inútiles (y útiles también, claro). Si alguna vez te preguntaste quién lee los manuales de instrucciones, aquí tienes la respuesta. 📚🔍</li>
        <li>Prefiere analizar antes de actuar, lo que significa que podría pasar media hora investigando qué serie ver en lugar de simplemente darle play a algo. 📺🧐</li>
        <li>Tiene un amor profundo por la privacidad, lo que puede llevarlo a estar más cómodo en su mente que en las reuniones sociales. Si pudiera enviarse mensajes a sí mismo para socializar, lo haría. 📵🌌</li>
        <li>Es increíblemente independiente, pero a veces esto lo hace desconfiar de las opiniones o la ayuda de los demás. 😬💡</li>
        <li>En su mejor versión, el Eneatipo 5 es una fuente de sabiduría, creatividad y soluciones inesperadas (el amigo que sabe cómo arreglar un grifo con un clip). ✨🛠️</li>
      </ul>

      <!-- Subtítulo adicional -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        ¿Te suena esto familiar?
      </h2>

      <!-- Preguntas adicionales -->
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Tienes una colección de datos inútiles que sacas en conversaciones random? (Por ejemplo, que un pulpo tiene tres corazones). 🐙💔
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Te sientes agotado después de una interacción social como si hubieras corrido un maratón? 🏃‍
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿A veces piensas demasiado las cosas hasta que se te pasa el momento de actuar? ⏳💭
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-6">
        El autoconocimiento puede ayudarte a equilibrar la reflexión con la acción, para que el mundo pueda beneficiarse de tus brillantes ideas (y no solo tú). 🌱
      </p>

      <!-- Cierre -->
      <p class="text-[16px] text-[#333333] leading-relaxed">
        Suscríbete ahora y recibe más información sobre el Eneatipo 5, junto con estrategias claras y prácticas para convertir tus características en herramientas de 
        crecimiento personal. Porque transformar tu vida empieza con un solo paso... ¡éste! 🚀
      </p>
    </div>
  `;
	  case '6':
  return `
    <div>
      <!-- Título -->
      <h1 class="text-[32px] font-bold font-serif text-[#00273C] text-center mb-6">
		¡El eneatipo que mejor se refleja en ti es el Eneatipo 6: El Dubitativo!
		</h1>

      <!-- Subtítulo -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        Estas son algunas de sus conductas:
      </h2>

      <!-- Lista de conductas -->
      <ul class="list-disc pl-6 text-[16px] text-[#333333] leading-relaxed mb-6">
        <li>Este eneatipo se caracteriza por su sentido de responsabilidad y compromiso. Es como esa persona que lleva paraguas "por si acaso" aunque el cielo esté despejado. ☂️☀️</li>
        <li>Analiza riesgos como si fuera un detective en una serie policiaca, siempre listo para proteger a los suyos. 🕵️‍🛡️</li>
        <li>Aunque valora la seguridad, a veces se enfrenta a un torbellino de dudas internas que lo lleva a pensar: "¿Y si esto no sale bien?". 🤔💭</li>
        <li>Puede buscar validación externa con más frecuencia de la que revisa su lista de tareas. 📋✔️</li>
        <li>En su mejor versión, el Eneatipo 6 aporta estabilidad, apoyo y una valentía contagiosa. 🌟💪</li>
      </ul>

      <!-- Subtítulo adicional -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        ¿Te suena esto familiar?
      </h2>

      <!-- Preguntas adicionales -->
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Sueles preparar mil planes alternativos aunque nunca llegues a usarlos? 🛠️
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Consultas a todos tus amigos para decidir hasta lo más simple, como qué película ver? 🍿🤷‍
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Sientes que tus miedos a veces te ponen el freno de mano justo cuando estás por avanzar? 🛑
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-6">
        El autoconocimiento puede ayudarte a encontrar confianza interna, permitiéndote avanzar con más seguridad y calma. 🌱
      </p>

      <!-- Cierre -->
      <p class="text-[16px] text-[#333333] leading-relaxed">
        Suscríbete ahora y recibe más información sobre el Eneatipo 6, junto con estrategias claras y prácticas para convertir sus 
        características en herramientas de crecimiento personal. Porque transformar tu vida empieza con un solo paso... ¡éste! 🚀
      </p>
    </div>
  `;
	  case '7':
  return `
    <div>
      <!-- Título -->
      <h1 class="text-[32px] font-bold font-serif text-[#00273C] text-center mb-6">
        ¡El eneatipo que mejor te describe es el Eneatipo 7: El Entusiasta!
      </h1>

      <!-- Subtítulo -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        Estas son algunas de sus conductas:
      </h2>

      <!-- Lista de conductas -->
      <ul class="list-disc pl-6 text-[16px] text-[#333333] leading-relaxed mb-6">
        <li>Este eneatipo es como un huracán de energía y optimismo. Siempre está buscando la próxima aventura, ya sea una clase de cocina o un viaje espontáneo a la playa. 🌊🍳</li>
        <li>Le cuesta quedarse quieto: “¿Un solo plan para el sábado? ¡Mejor cinco!” 🏃‍♀️🎉️</li>
        <li>Evita las emociones negativas como si fueran un spoiler de su serie favorita: no quiere enfrentarlas. 🙃</li>
        <li>Tiende a enfocarse en lo que podría ser, lo que a veces lo desconecta del presente. Pero cuando está aquí y ahora, ¡es pura chispa! ✨🔥</li>
        <li>En su mejor versión, el Eneatipo 7 es un faro de inspiración, creatividad y alegría que contagia a todos. 🌈💖</li>
      </ul>

      <!-- Subtítulo adicional -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        ¿Te suena esto familiar?
      </h2>

      <!-- Preguntas adicionales -->
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Tienes más ideas de las que puedes llevar a cabo (y eso no te impide seguir generando nuevas)? 💡
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Sientes que necesitas mantenerte ocupado(a) porque el silencio te hace pensar demasiado? 🤔
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿A veces tienes tanto entusiasmo por empezar cosas nuevas que olvidaste terminar las anteriores? 🛠️
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-6">
        El autoconocimiento puede ayudarte a encontrar un equilibrio entre tu energía desbordante y el enfoque necesario para disfrutar plenamente del presente. 🌱
      </p>

      <!-- Cierre -->
      <p class="text-[16px] text-[#333333] leading-relaxed">
        Suscríbete ahora y recibe más información sobre el Eneatipo 7, junto con estrategias claras y prácticas para convertir tus características en herramientas 
        de crecimiento personal. Porque transformar tu vida empieza con un solo paso... ¡éste! 🚀
      </p>
    </div>
  `;	
	  case '8':
  return `
    <div>
      <!-- Título -->
      <h1 class="text-[32px] font-bold font-serif text-[#00273C] text-center mb-6">
        ¡El eneatipo que mejor te describe es el Eneatipo 8: El Desafiador!
      </h1>

      <!-- Subtítulo -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        Estas son algunas de sus conductas:
      </h2>

      <!-- Lista de conductas -->
      <ul class="list-disc pl-6 text-[16px] text-[#333333] leading-relaxed mb-6">
        <li>Este eneatipo es como un motor turbo: directo, intenso y siempre listo para la acción. ¿Alguien dijo "desafío"? ¡Aceptado! 💥⚡</li>
        <li>No le teme a los conflictos, de hecho, puede incluso disfrutarlos un poco (o mucho). Para él, decir las cosas como son no es rudeza, es honestidad. 🗣️🔥</li>
        <li>Suele tomar el control de las situaciones, lo que lo convierte en un líder nato, pero a veces en "el jefe que nadie pidió". 😅👑</li>
        <li>Aprecia la fortaleza y puede proteger a los suyos como un escudo humano, pero rara vez deja ver su lado más vulnerable. 🛡️</li>
        <li>En su mejor versión, inspira con su valentía, generosidad y capacidad para luchar por lo que cree justo. 🌟💪</li>
      </ul>

      <!-- Subtítulo adicional -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        ¿Te suena esto familiar?
      </h2>

      <!-- Preguntas adicionales -->
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Prefieres liderar una situación antes que quedarte esperando a que alguien más tome la iniciativa (aunque sea armar la mesa en una boda)? 👰‍🍴
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Sientes que la vulnerabilidad es como mostrar tu contraseña de banco en público? 💻🔒
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿A veces tu intensidad hace que los demás pidan una tregua antes de terminar la conversación? 🏳️
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-6">
        El autoconocimiento puede ayudarte a encontrar un equilibrio entre tu fuerza y tu sensibilidad, para que lideres sin agotarte y conectes desde el corazón. 🌱
      </p>

      <!-- Cierre -->
      <p class="text-[16px] text-[#333333] leading-relaxed">
        Suscríbete ahora y recibe más información sobre el Eneatipo 8, junto con estrategias claras y prácticas para convertir tus características en herramientas de 
        crecimiento personal. Porque transformar tu vida empieza con un solo paso... ¡éste! 🚀
      </p>
    </div>
  `;
	  case '9':
  return `
    <div>
      <!-- Título -->
      <h1 class="text-[32px] font-bold font-serif text-[#00273C] text-center mb-6">
        ¡El eneatipo que mejor te describe es el Eneatipo 9: El Pacifista!
      </h1>

      <!-- Subtítulo -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        Estas son algunas de sus conductas:
      </h2>

      <!-- Lista de conductas -->
      <ul class="list-disc pl-6 text-[16px] text-[#333333] leading-relaxed mb-6">
        <li>Este eneatipo es como el diplomático de un grupo: siempre buscando armonía, incluso si eso significa ignorar sus propios deseos para evitar conflictos. "¿Qué quiero cenar? Lo que tú quieras está bien". 🕊️🍕</li>
        <li>Tiene una habilidad especial para ver todos los puntos de vista, lo que lo convierte en el mediador perfecto (aunque decidir algo pueda tomarle una eternidad). 🕰️🤔</li>
        <li>Tiende a evitar los problemas como si fueran anuncios publicitarios en YouTube: ignora, salta y sigue. 📺⏭️</li>
        <li>A veces puede desconectarse de sus emociones o necesidades, prefiriendo la paz exterior al caos interior. 🌊🙃️</li>
        <li>En su mejor versión, es una fuente de estabilidad, empatía y tranquilidad que inspira a los demás a encontrar equilibrio. 🌟💞</li>
      </ul>

      <!-- Subtítulo adicional -->
      <h2 class="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
        ¿Te suena esto familiar?
      </h2>

      <!-- Preguntas adicionales -->
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Sientes que prefieres ceder en una discusión antes que enfrentar un conflicto (aunque no estés de acuerdo)? 🤷‍
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿Tienes tanto talento para procrastinar que incluso podrías posponer ganar la lotería? 🎟️
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-4">
        ¿A veces te sientes tan atrapado en mantener la paz que terminas olvidando lo que realmente quieres? 💭
      </p>
      <p class="text-[16px] text-[#333333] leading-relaxed mb-6">
        El autoconocimiento puede ayudarte a encontrar tu voz, a priorizar tus necesidades y a vivir con más autenticidad (sin sacrificar la paz que tanto valoras). 🌱
      </p>

      <!-- Cierre -->
      <p class="text-[16px] text-[#333333] leading-relaxed">
        Suscríbete ahora y recibe más información sobre el Eneatipo 9, junto con estrategias claras y prácticas para convertir tus características en herramientas de crecimiento personal. Porque transformar tu vida empieza con un solo paso... ¡éste! 🚀
      </p>
    </div>
  `;
      
      default:
        return 'Tipo de eneagrama no reconocido.';
    }
  };
  
 
  

  const eneagramMessage = getEneagramMessage(eneagramType);

  const getEmailContent = (type) => {
    switch (type) {
      case '1':
        return `
          ¡Hola! 🎉
          Gracias por dar el primer paso hacia tu autodescubrimiento.
          Aquí tienes más información sobre las características principales del Eneatipo 1: El Perfeccionista, para que puedas usarlas a tu favor y empezar tu transformación (sin estrés, prometido 🖐️):
          
          Características del ego (cuando las cosas se complican):
          • Tiendes a ser demasiado exigente contigo mismo/a y con los demás, porque quieres que todo salga bien. 🧐
          • Te frustras fácilmente cuando las cosas no cumplen con tus estándares. 😤
          • Luchas por mantener todo bajo control, lo que puede generarte mucha ira y presión interna. 😅
          
          Características de la esencia (cuando estás en tu mejor versión):
          • Inspiras confianza y respeto por tu coherencia y firmeza. ✨
          • Tienes una gran capacidad para detectar oportunidades de mejora sin perder de vista el propósito general. 🪄
          • Sabes conectar desde la integridad y la compasión, creando un impacto positivo en quienes te rodean. 💞
          
          Estrategias de transformación (y cómo pueden cambiarlo todo):
          • Dedica tiempo a disfrutar sin perfección.
          • Aprende a soltar el control.
          
          Imagina tu vida…
          Una vida donde tu crítica interna no tenga micrófono, donde disfrutes sin preocuparte por el resultado, y donde tengas la confianza para dar pasos grandes hacia tus sueños. Porque sí, esos sueños son 100% alcanzables (y más fáciles sin tanto estrés). 🚀
          
          ¿Y ahora qué?
          El Eneagrama es solo el calentamiento. Como coach, puedo ayudarte a transformar estas ideas en acciones reales, y a convertir tu perfección frustrante en un motor que te impulse hacia una vida próspera (y mucho más divertida).
          📅 Reserva una sesión conmigo y construyamos esa vida próspera que tanto anhelas.
          👉 Haz clic aquí para más información (link WhatsApp: https://wa.me/message/6V77XEHZYKXEA1)
          
          Con cariño (y menos perfección),
          Tu coach, Sandra
          
          Únete a mi comunidad:
          Instagram: https://www.instagram.com/lavainacorp/
          Facebook: https://www.facebook.com/lavainacorp
          TikTok: https://www.tiktok.com/@lavainacorp
          YouTube: https://www.youtube.com/@sandralancea
          LinkedIn: https://www.linkedin.com/in/sandralance/
        `;
      case '2':
        return `
          ¡Hola! 🎉
		  Gracias por dar el primer paso hacia tu autodescubrimiento.
		  Aquí tienes más información sobre las características principales del Eneatipo 2: El Ayudador, para que puedas usarlas a tu favor y empezar tu transformación (sin estrés, prometido 🖐️):
		  
		  Características del ego (cuando las cosas se complican):
		  •	Te frustra cuando sientes que ayudas constantemente, pero nadie parece notarlo. 😤
		  •	Tiendes a poner las necesidades de los demás antes que las tuyas, lo que puede agotarte. 🙃
		  •	Buscas aprobación a través de lo que haces por otros, pero eso puede hacerte sentir invisible si no recibes reconocimiento. 🫥
		  
		  Características de la esencia (cuando estás en tu mejor versión):
		  •	Conectas con las personas de una manera auténtica, haciendo que se sientan valoradas. 💖
		  •	Sabes que tu valor no está en lo que haces, sino en quién eres. 🌟
		  •	Encuentras equilibrio cuidándote tanto como cuidas de los demás. 🌈
		  
		  Estrategias de transformación (y cómo pueden cambiarlo todo):
		  •	Dite "sí" a ti mismo(a).
		  
		  Reserva tiempo para tus propios deseos y necesidades. Imagínate diciendo "no" sin culpa y "sí" a las cosas que realmente te llenan. ¡Es liberador! ✨
		  •	Aprende a recibir ayuda.
		  
		  Es válido no ser el soporte de todo el mundo. Deja que otros también te cuiden y visualiza cómo sería una vida donde no tienes que llevar todo el peso. 👐
		  
		  Imagina tu vida…		  
		  Una vida donde ayudas desde la abundancia, no desde la obligación. Donde el amor que das regresa a ti, y donde encuentras fuerza en cuidarte primero. Porque cuidar de ti no solo te hace más fuerte, ¡también más feliz! 💃🕺

		  ¿Y ahora qué?
		  El Eneagrama es solo el comienzo. Como coach, puedo ayudarte a convertir estas ideas en acciones prácticas y a crear relaciones equilibradas, llenas de autenticidad y amor propio.
		  📅 Reserva una sesión conmigo y construyamos esa vida próspera que tanto anhelas.
		  👉 Haz clic aquí para más información (link WhatsApp: https://wa.me/message/6V77XEHZYKXEA1)
		  
		  Con cariño (y menos apego),
		  Tu coach, Sandra

		  Únete a mi comunidad 
		  Instagram:  https://www.instagram.com/lavainacorp/
		  Facebook: https://www.facebook.com/lavainacorp
		  TikTok:  https://www.tiktok.com/@lavainacorp
		  YouTube:  https://www.youtube.com/@sandralancea
		  LinkedIn:  https://www.linkedin.com/in/sandralance/
        `;
	  case '3':
        return `
          ¡Hola! 🎉
		  Gracias por dar el primer paso hacia tu autodescubrimiento.
		  Aquí tienes más información sobre las características principales del Eneatipo 3: El Triunfador, para que puedas usarlas a tu favor y empezar tu transformación (sin agotarte en el camino, prometido 🖐️):
		  
		  Características del ego (cuando las cosas se complican):
		  •	Tiendes a medir tu valor por tus logros, como si tu vida fuera un currículum andante. 📄😅
		  •	A veces te desconectas de tus emociones, porque ¿quién tiene tiempo para sentir cuando hay metas que alcanzar? 🤖💼
		  •	Buscas validación externa, lo que puede hacer que te sientas como en una eterna competencia de popularidad. 🏅
		  
		  Características de la esencia (cuando estás en tu mejor versión):
	      •	Lideras con autenticidad, inspirando a otros no solo por lo que haces, sino por quién eres. 🌟
		  •	Reconoces que el éxito también incluye tiempo para ti mismo(a), tus emociones y esa siesta merecida. 😴
		  •	Disfrutas del camino tanto como de la meta, encontrando satisfacción en cada paso. 🚴‍♂️🌈
		  
		  Estrategias de transformación (y cómo pueden cambiarlo todo):
		  •	Tómate un descanso consciente.
		  
		  Agenda (sí, ponlo en tu agenda) un tiempo para relajarte y conectar contigo mismo(a), sin objetivos ni metas. Imagina cómo sería recargar energías sin sentir culpa por "no hacer nada". ✨
		  •	Define el éxito en tus propios términos.
		  
		  Escribe qué significa realmente el éxito para ti, más allá de los aplausos y reconocimientos. Visualiza una vida donde tus logros reflejen tus valores y no solo expectativas externas. 🌟
		  
		  Imagina tu vida…
		  Una vida donde tus logros son una expresión de quién eres, no una máscara. Donde lideras con confianza y autenticidad, inspirando a otros y disfrutando cada momento sin la presión constante de "¿qué sigue?". Porque tú eres más que una lista de éxitos, ¡eres único(a) y auténtico(a)! 🚀
		  
		  ¿Y ahora qué?
		  El Eneagrama es solo el comienzo. Como coach, puedo ayudarte a convertir estas ideas en un plan práctico para alcanzar tus metas sin agotarte y construir una vida más equilibrada y auténtica.
		  📅 Reserva una sesión conmigo y construyamos esa vida próspera que tanto anhelas.
		  👉 Haz clic aquí para más información (link WhatsApp: https://wa.me/message/6V77XEHZYKXEA1)

		  Con cariño (y más autenticidad),
		  Tu coach, Sandra

		  Únete a mi comunidad 
		  Instagram:  https://www.instagram.com/lavainacorp/
		  Facebook: https://www.facebook.com/lavainacorp
		  TikTok:  https://www.tiktok.com/@lavainacorp
		  YouTube:  https://www.youtube.com/@sandralancea
		  LinkedIn:  https://www.linkedin.com/in/sandralance/

        `;
	  case '4':
        return `
          ¡Hola! 🎉
		  Gracias por dar el primer paso hacia tu autodescubrimiento.
    	  Aquí tienes más información sobre las características principales del Eneatipo 4: El Especial, para que puedas usarlas a tu favor y empezar tu transformación (sin dramas innecesarios, lo prometo 🖐️):
		  
		  Características del ego (cuando las cosas se complican):
		  •	Tiendes a sentir que siempre te falta algo para ser completamente feliz, como si estuvieras esperando la banda sonora perfecta de tu vida. 🎻😟
		  •	Las emociones intensas a veces te hacen sentir como el protagonista de una novela existencial. 📖🌊
		  •	Compararte con los demás puede convertirse en un deporte que siempre parece perderse. 🪞
		  
		  Características de la esencia (cuando estás en tu mejor versión):
		  •	Transformas tus emociones en creatividad que inspira a quienes te rodean. 🎨✨
		  •	Abrazas tu singularidad, reconociendo que no necesitas encajar en ningún molde para brillar. 🌟
		  •	Encuentras equilibrio al expresar tus emociones con claridad y sin perderte en ellas. 🌈
		  
		  Estrategias de transformación (y cómo pueden cambiarlo todo):
		  •	Conecta con tu presente.
		  
		  Dedica 5 minutos al día para escribir tres cosas simples que te hagan feliz hoy (¡sí, un buen café cuenta!). Esto te ayudará a centrarte en lo que tienes, en lugar de lo que crees que te falta. ✍️✨
		  •	Crea antes de pensar.
		  
		  Cuando te sientas atrapado en tus emociones, conviértelas en algo tangible: dibuja, escribe o crea algo, aunque sea un garabato. Visualiza cómo sería transformar tus sentimientos en arte y no solo en pensamientos. 🎭🖌️
		
		  Imagina tu vida…
		  Una vida donde no necesitas compararte para sentirte completo/a, donde las emociones son tu aliado creativo y donde tu autenticidad inspira a los demás. Porque ser tú mismo/a no solo es suficiente, ¡es transformador! 🚀
			
		  ¿Y ahora qué?
		  El Eneagrama es solo el comienzo. Como coach, puedo ayudarte a convertir estas ideas en un plan práctico para transformar tus emociones y construir una vida llena de propósito y creatividad.
		  📅 Reserva una sesión conmigo y construyamos esa vida próspera que tanto anhelas.
		  👉 Haz clic aquí para más información (link WhatsApp: https://wa.me/message/6V77XEHZYKXEA1)
			
		  Con cariño (y menos dramas),
		  Tu coach, Sandra

		  Únete a mi comunidad 
		  Instagram:  https://www.instagram.com/lavainacorp/
		  Facebook: https://www.facebook.com/lavainacorp
		  TikTok:  https://www.tiktok.com/@lavainacorp
		  YouTube:  https://www.youtube.com/@sandralancea
		  LinkedIn:  https://www.linkedin.com/in/sandralance/

        `;
	  case '5':
        return `
          ¡Hola! 🎉
		  Gracias por dar el primer paso hacia tu autodescubrimiento.
		  Aquí tienes más información sobre las características principales del Eneatipo 5: El Observador, para que puedas usarlas a tu favor y empezar tu transformación (sin atascarte en el análisis, prometido 🖐️):
		  
		  Características del ego (cuando las cosas se complican):
		  •	Tiendes a acumular información como si te estuvieras preparando para una trivia universal que nunca llega. 📚🔄
		  •	A veces, la idea de necesitar ayuda de alguien más puede parecer tan aterradora como pedir pizza por teléfono. 📞😅
		  •	Te gusta tanto analizar las cosas que terminas con un archivo mental, pero sin acción concreta. 🗂️
		  
		  Características de la esencia (cuando estás en tu mejor versión):
		  •	Tu sabiduría aporta claridad y soluciones a problemas que nadie más ve. 💡🛠️
		  •	Encuentras el equilibrio entre disfrutar de tu soledad y compartir tus ideas con los demás. 🌌🤝
		  •	Inspiras con tu calma y capacidad de mirar más allá de lo superficial. ✨
		  
		  Estrategias de transformación (y cómo pueden cambiarlo todo):
		  •	Pon límites al tiempo de análisis.
		  
		  Cuando sientas que estás entrando en un bucle mental, establece un temporizador de 15 minutos para decidir qué hacer con lo que ya sabes. Después, ¡actúa sin mirar atrás! Visualiza cómo sería llevar tus ideas a la práctica y sorprender al mundo… Y a ti mismo(a). 🚀
		  •	Comparte tu sabiduría.
		  
		  El próximo dato curioso que aprendas, úsalo como una oportunidad para conectar. Imagina cómo sería compartir tus conocimientos con alguien y descubrir que, además de inteligente, eres increíblemente interesante. 🌟
		
		  Imagina tu vida…
		  Una vida donde tus ideas se convierten en acciones que impactan a otros, donde tu independencia no te aísla y donde disfrutas tanto de tus logros como de tu tiempo a solas. Porque tu sabiduría es tu superpoder, ¡y el mundo la necesita! 🌍🚀
		  
		  ¿Y ahora qué?
		  El Eneagrama es solo el comienzo. Como coach, puedo ayudarte a transformar tus ideas en resultados y construir una vida que equilibre tu mundo interno con tus metas externas.
		  📅 Reserva una sesión conmigo y construyamos esa vida próspera que tanto anhelas.
		  👉 Haz clic aquí para más información (link WhatsApp: https://wa.me/message/6V77XEHZYKXEA1)

		  Con cariño (y más acción),
		  Tu coach, Sandra

		  Únete a mi comunidad 
		  Instagram:  https://www.instagram.com/lavainacorp/
		  Facebook: https://www.facebook.com/lavainacorp
		  TikTok:  https://www.tiktok.com/@lavainacorp
		  YouTube:  https://www.youtube.com/@sandralancea
		  LinkedIn:  https://www.linkedin.com/in/sandralance/
        `;
	  case '6':
        return `
          ¡Hola! 🎉
		  Gracias por dar el primer paso hacia tu autodescubrimiento.
		  Aquí tienes más información sobre las características principales del Eneatipo 6: El Dubitativo, para que puedas usarlas a tu favor y empezar tu transformación (sin alarmas innecesarias, prometido 🖐️):
		  
		  Características del ego (cuando las cosas se complican):
		  •	Sueles preocuparte por los famosos "¿y si...?", como si estuvieras dirigiendo un tráiler de película apocalíptica. 🎥😟
		  •	A veces te cuesta confiar en tus propias decisiones y terminas sometiéndolas a consulta popular. 🗳️🤔
		  •	Tu necesidad de evitar riesgos puede llevarte a quedarte más tiempo de lo necesario en la zona de confort. 🛋️
		  
		  Características de la esencia (cuando estás en tu mejor versión):
		  •	Eres esa roca firme que todos necesitan en momentos de caos, aportando estabilidad y calma. 🛡️✨
		  •	Enfrentas tus miedos con valentía, inspirando a otros a hacer lo mismo. 🌟💪
		  •	Logras encontrar un balance entre ser precavido(a) y actuar con confianza. 🚀
		  
		  Estrategias de transformación (y cómo pueden cambiarlo todo):
		  •	Confía en tu instinto.
		
		  Cuando te invadan las dudas, escribe una lista con los pros y los contras, y actúa sin pedir la opinión de toda tu agenda de contactos. Visualiza cómo sería confiar en ti mismo/a y avanzar con seguridad. 💪✨
		  •	Dale un descanso a tu sobrepensamiento.
		  
		  Pon un temporizador de 10 minutos para tomar una decisión y luego lánzate. Imagina cómo sería sentir la libertad de actuar sin tantas vueltas. ⏳✔️
		
		  Imagina tu vida…
		  Una vida donde la confianza interna sea tu brújula, donde tus miedos se conviertan en aliados que te empujan hacia adelante, y donde disfrutes del camino sin preocuparte tanto por los "¿y si…?". Porque la valentía también es tu superpoder. 🚀
		
		  ¿Y ahora qué?
		  El Eneagrama es solo el comienzo. Como coach, puedo ayudarte a convertir estas ideas en un plan práctico para avanzar con seguridad y construir una vida alineada con tus valores.
		  📅 Reserva una sesión conmigo y construyamos esa vida próspera que tanto anhelas.
		  👉 Haz clic aquí para más información (link WhatsApp: https://wa.me/message/6V77XEHZYKXEA1)

		  Con cariño (y menos dudas),
		  Tu coach, Sandra

		  Únete a mi comunidad 
		  Instagram:  https://www.instagram.com/lavainacorp/
		  Facebook: https://www.facebook.com/lavainacorp
		  TikTok:  https://www.tiktok.com/@lavainacorp
		  YouTube:  https://www.youtube.com/@sandralancea
		  LinkedIn:  https://www.linkedin.com/in/sandralance/

        `;
	  case '7':
        return `
          ¡Hola! 🎉
		  Gracias por dar el primer paso hacia tu autodescubrimiento.
		  Aquí tienes más información sobre las características principales del Eneatipo 7: El Entusiasta, para que puedas usarlas a tu favor y empezar tu transformación (sin dejar de divertirte, prometido 🖐️):
		  
		  Características del ego (cuando las cosas se complican):
		  •	Tiendes a evitar cualquier cosa que huela a aburrimiento o emociones incómodas (¿tristeza? No, gracias). 😅
		  •	Puedes perderte en una cascada de ideas, haciendo malabares con tantas opciones que a veces ninguna se concreta. 🤹‍
		  •	El miedo a quedarte fuera de algo interesante te hace decir “sí” a todo, terminando agotado(a). 🪫
		  
		  Características de la esencia (cuando estás en tu mejor versión):
		  •	Eres una fuente inagotable de alegría y creatividad, inspirando a los demás con tu energía. 🌈💡
		  •	Encuentras satisfacción en lo que haces, sin necesidad de perseguir siempre “lo próximo”. 🌟
		  •	Gestionas la tristeza como un aliado, aprendiendo de ella y permitiéndote sentir sin temor a quedarte atrapado/a en el dolor. 🌊💖
		  
		  Estrategias de transformación (y cómo pueden cambiarlo todo):
		  •	Dale una pausa a tu lista de pendientes.
		  
		  Elige una sola idea o proyecto para completar esta semana. Imagina la satisfacción de terminar algo y verlo florecer. No necesitas mil planes, solo uno que te haga feliz. 🌻
		  •	Haz espacio para tus emociones.
		  
		  Dedica cinco minutos al día para conectar con lo que sientes, sin cambiarlo ni evitarlo. Visualiza cómo sería abrazar tus emociones como parte de tu experiencia de vida, no como un obstáculo. 🌊
		  
		  Imagina tu vida…
		  Una vida donde tu entusiasmo te impulsa sin agotarte, donde disfrutas del presente sin miedo a perderte algo, y donde cada proyecto que empiezas tiene la oportunidad de brillar. Porque cuando combinas tu energía con enfoque, ¡puedes lograrlo todo! 🚀
		  
		  ¿Y ahora qué?
		  El Eneagrama es solo el comienzo. Como coach, puedo ayudarte a equilibrar tu entusiasmo con enfoque y construir una vida plena, divertida y llena de propósito.
		  📅 Reserva una sesión conmigo y construyamos esa vida próspera que tanto anhelas.
		  👉 Haz clic aquí para más información (link WhatsApp: https://wa.me/message/6V77XEHZYKXEA1)
		  
		  Con cariño (y más vivir el presente),
		  Tu coach, Sandra
		  
		  Únete a mi comunidad 
		  Instagram:  https://www.instagram.com/lavainacorp/
		  Facebook: https://www.facebook.com/lavainacorp
		  TikTok:  https://www.tiktok.com/@lavainacorp
		  YouTube:  https://www.youtube.com/@sandralancea
		  LinkedIn:  https://www.linkedin.com/in/sandralance/
        `;
	  case '8':
        return `
          ¡Hola! 🎉
		  Gracias por dar el primer paso hacia tu autodescubrimiento.
		  Aquí tienes más información sobre las características principales del Eneatipo 8: El Desafiador, para que puedas usarlas a tu favor y empezar tu transformación (sin quemar puentes, prometido 🖐️):
		  
		  Características del ego (cuando las cosas se complican):
		  •	Sueles creer que mostrar vulnerabilidad es lo mismo que perder el control, así que te aseguras de que nadie vea tus emociones. 🔒
		  •	Tienes una necesidad constante de ser fuerte, lo que a veces puede parecer intimidante para quienes te rodean. 💪😅
		  •	Tiendes a reaccionar intensamente ante situaciones injustas, sin importar si estás en la fila del supermercado o en una reunión de trabajo. 🛒🔥
		  
		  Características de la esencia (cuando estás en tu mejor versión):
		  •	Luchas por lo que es justo, con una valentía que inspira a todos. 🌟💡
		  •	Conectas desde tu fortaleza y también desde tu vulnerabilidad, creando relaciones auténticas y significativas. 🤝💖
		  •	Tu capacidad de liderazgo impulsa a los demás a alcanzar su máximo potencial (sin necesidad de gritar instrucciones). 🌈✨
		  
		  Estrategias de transformación (y cómo pueden cambiarlo todo):
		  •	Abraza tu lado vulnerable.
		  
		  Practica compartir un pensamiento o emoción sincera con alguien de confianza. Visualiza cómo sería ser fuerte desde tu autenticidad, sin necesidad de demostrar nada. 🌊✨
		  •	Dale un descanso a tu intensidad.
		  
		  Antes de reaccionar, cuenta hasta cinco (o diez, si es necesario). Imagina cómo sería liderar desde la calma y ver cómo los demás responden positivamente a tu equilibrio. 🌟
		  
		  Imagina tu vida…
		  Una vida donde lideras con valentía y corazón, donde no necesitas demostrar tu fuerza constantemente, y donde tus relaciones crecen gracias a tu autenticidad. Porque ser fuerte también incluye cuidar de ti mismo(a). 🚀
		  
		  ¿Y ahora qué?
		  El Eneagrama es solo el comienzo. Como coach, puedo ayudarte a equilibrar tu intensidad y construir una vida donde lideres con confianza, conexión y propósito.
		  📅 Reserva una sesión conmigo y construyamos esa vida próspera que tanto anhelas.
		  👉 Haz clic aquí para más información (link WhatsApp: https://wa.me/message/6V77XEHZYKXEA1)

		  Con cariño (y menos intensidad),
		  Tu coach, Sandra

		  Únete a mi comunidad 
		  Instagram:  https://www.instagram.com/lavainacorp/
		  Facebook: https://www.facebook.com/lavainacorp
		  TikTok:  https://www.tiktok.com/@lavainacorp
		  YouTube:  https://www.youtube.com/@sandralancea
		  LinkedIn:  https://www.linkedin.com/in/sandralance/

        `;
	  case '9':
        return `
          ¡Hola! 🎉
		  Gracias por dar el primer paso hacia tu autodescubrimiento.
		  Aquí tienes más información sobre las características principales del Eneatipo 9: El Pacifista, para que puedas usarlas a tu favor y empezar tu transformación (sin sacrificar tu paz, prometido 🖐️):
		  
		  Características del ego (cuando las cosas se complican):
		  •	Tiendes a evitar los conflictos, aunque eso signifique decir "sí" a cosas que realmente no quieres hacer. 😅
		  •	A veces priorizas tanto la comodidad y la calma que dejas tus necesidades al final de la lista (o fuera de ella). 🛋️
		  •	Puedes procrastinar en la toma de decisiones porque ves demasiadas opciones. 📜🤯
		  
		  Características de la esencia (cuando estás en tu mejor versión):
		  •	Conectas profundamente con los demás, ofreciendo una tranquilidad y empatía que son como un abrazo para el alma. 💞
		  •	Encuentras tu propia voz, tomando decisiones que reflejan tus valores sin temor a perturbar la armonía. 🌟
		  •	Inspiras a quienes te rodean con tu capacidad para encontrar paz, incluso en medio del caos. 🌈
		  
		  Estrategias de transformación (y cómo pueden cambiarlo todo):
		  •	Expresa lo que realmente piensas (con calma).
		  
		  Elige una conversación diaria donde normalmente cederías, y practica compartir tu opinión genuina, aunque sea algo pequeño, como qué cenar o qué película ver. Imagina cómo sería fortalecer tus relaciones siendo honesto/a sobre lo que quieres, sin miedo al conflicto. ¡Tu voz también merece espacio! 🍿🗣️💞
		  •	Rompe el piloto automático con pequeños cambios.
		  
		  Haz algo diferente cada día, como elegir un camino nuevo para ir al trabajo o probar un plato que nunca has cocinado. Estos pequeños pasos te ayudarán a salir de la rutina y a reconectar con lo que te hace sentir vivo/a. Visualiza cómo sería descubrir nuevas facetas de ti mismo/a mientras mantienes tu paz interior. 🚶‍♀️🍲✨

		  Imagina tu vida…
		  Una vida donde encuentras paz tanto dentro como fuera de ti, donde tus necesidades son tan importantes como las de los demás, y donde cada decisión refleja lo que realmente quieres. Porque priorizarte no rompe la armonía, ¡la mejora! 🚀
		  
		  ¿Y ahora qué?
		  El Eneagrama es solo el comienzo. Como coach, puedo ayudarte a encontrar tu equilibrio interno y a construir una vida donde la paz, la autenticidad y tus metas convivan en perfecta armonía.
		  📅 Reserva una sesión conmigo y construyamos esa vida próspera que tanto anhelas.
		  👉 Haz clic aquí para más información (link WhatsApp: https://wa.me/message/6V77XEHZYKXEA1)

		  Con cariño (y menos procrastinación),
		  Tu coach, Sandra

		  Únete a mi comunidad 
		  Instagram:  https://www.instagram.com/lavainacorp/
		  Facebook: https://www.facebook.com/lavainacorp
		  TikTok:  https://www.tiktok.com/@lavainacorp
		  YouTube:  https://www.youtube.com/@sandralancea
		  LinkedIn:  https://www.linkedin.com/in/sandralance/

        `;	
	  
	  
     
      default:
        return 'Tipo de eneagrama no reconocido.';
    }
  };

  

const handleSendEmail = async (e) => {
    e.preventDefault();
    setSending(true);
    setSendStatus(null);

    try {
        
        if (!eneagramType) {
            throw new Error('No se pudo determinar el tipo de eneagrama.');
        }

       
        const response = await fetch('https://sandralancea.com/wp-json/custom/v1/send-email-and-subscribe/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: email,
                eneagramType: eneagramType,
				whatsapp: `${countryCode} ${whatsapp}`,
            }),
        });

       
        const responseData = await response.json();

        
        if (!response.ok) {
            throw new Error(responseData.message || 'Error al enviar los resultados.');
        }

       
        setSendStatus('success');
    } catch (error) {
        
        console.error('Error:', error);
        setSendStatus('error');
        alert(error.message); 
    } finally {
        setSending(false);
    }
};


const handleSubscribe = () => {
    setShowEmailForm(true); 
};


	const getBarColor = (number) => {
    if ([8, 9, 1].includes(Number(number))) return 'bg-red'; 
    if ([2, 3, 4].includes(Number(number))) return 'bg-green';
    if ([5, 6, 7].includes(Number(number))) return 'bg-blue';
    return '';
	};

	const generateBlocks = (currentScore, maxScore, type) => {
    const totalBlocks = 16; 
    const filledBlocks = Math.round((currentScore / maxScore) * totalBlocks);
    const blockWidth = 100 / totalBlocks; 

    return Array.from({ length: totalBlocks }, (_, index) => (
        <div
            key={index}
            className={`h-full ${index < filledBlocks ? getBarColor(type) : "bg-gray-300 opacity-50"} transition-all`}
            style={{ width: `${blockWidth}%` }}
        ></div>
    ));
	};

	
	
	
	
  return (
    //<div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12 px-4">
	<div className="min-h-screen bg-white py-12 px-4">
      {/* Header con el logo */}
      <header className="py-4 bg-transparent flex justify-center">
        <img
          src="/logoresultado.svg"
          alt="Logo Resultado"
          className="h-[87px] w-[170px]"
        />
      </header>

      <div className="max-w-4xl mx-auto p-4">
        {/* Título principal */}
        <h1 className="text-[32px] font-serif text-[#00273C] text-center mb-8">
          
        </h1>

        {/* Subtítulo */}
        <h2 className="font-bold text-[24px] text-[#23B3A8] text-center mb-8">
         
        </h2>

        {/* Mensaje del eneatipo */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <div dangerouslySetInnerHTML={{ __html: eneagramMessage }} />
        </div>

        {/* Subtítulo */}
        <h3 className="font-bold text-[24px] text-[#23B3A8] text-center mb-8">
        
        </h3>

        {/* Puntuaciones por tipo */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <div className="grid grid-cols-3 gap-4 text-center mb-6 border-b pb-4">
            <div className="font-semibold text-gray-600">Tipo</div>
            <div className="font-semibold text-gray-600">Indicador</div>
            <div className="font-semibold text-gray-600">Puntaje</div>
          </div>
          <div className="space-y-4">
            {["8", "9", "1", "2", "3", "4", "5", "6", "7"].map((type) => (
              <div key={type} className="grid grid-cols-3 items-center gap-4">
                <div className="text-center font-bold text-xl text-gray-700">{type}</div>
                <div className="relative flex-1">
                  <div className="flex items-center w-full bg-gray-200 h-6 rounded-lg">
                    {generateBlocks(personalityScores[type] || 0, 32, type)}
                  </div>
                </div>
                <div className="text-center font-bold text-xl">{personalityScores[type] || 0}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Triadas */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
  <div className="text-center p-4 rounded-lg bg-red-50 border border-red-200 min-w-0 break-words">
    <div className="text-red-600 font-bold mb-2 text-sm sm:text-base">Visceral</div>
    <div className="text-2xl sm:text-3xl font-bold text-red-700">{triadScores.visceral}</div>
  </div>
  <div className="text-center p-4 rounded-lg bg-green-50 border border-green-200 min-w-0 break-words">
    <div className="text-green-600 font-bold mb-2 text-sm sm:text-base">Emocional</div>
    <div className="text-2xl sm:text-3xl font-bold text-green-700">{triadScores.emocional}</div>
  </div>
  <div className="text-center p-4 rounded-lg bg-blue-50 border border-blue-200 min-w-0 break-words">
    <div className="text-blue-600 font-bold mb-2 text-sm sm:text-base">Mental</div>
    <div className="text-2xl sm:text-3xl font-bold text-blue-700">{triadScores.mental}</div>
  </div>
</div>

        {/* Botón de Suscribir ahora */}
<button
  type="button"
  onClick={handleSubscribe}
  className="mt-4 w-full px-6 py-3 bg-green-500 text-white font-sans text-[16px] rounded-[25px] 
    hover:bg-green-600 transition-colors duration-200 shadow-md"
>
  SUSCRIBIRSE AHORA
</button>

{/* Formulario de envío */}
{showEmailForm && (
  <div className="mt-8 p-6 bg-white rounded-lg shadow">
    {/* Subtítulo */}
    <h3 className="font-bold text-[24px] text-[#23B3A8] text-center mb-6">
      Enviar resultados por correo electrónico
    </h3>

    {/* Formulario */}
<form onSubmit={handleSendEmail} className="space-y-4">
  <div>
    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
      Correo electrónico del destinatario
    </label>
    <input
      type="email"
      id="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      className="w-full max-w-sm px-2 py-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
      required
      placeholder="ejemplo@correo.com"
    />
  </div>


  {/* Botón ENVIAR RESULTADOS */}
  <button
    type="submit"
    disabled={sending}
    className="w-full px-6 py-3 bg-black text-white font-sans text-[16px] rounded-[25px] 
      hover:bg-gray-800 transition-colors duration-200 shadow-md disabled:opacity-50"
  >
    {sending ? 'Enviando...' : 'ENVIAR RESULTADOS'}
  </button>

  {/* Mensajes de estado */}
  {sendStatus === 'success' && (
    <p className="text-green-500 text-center mt-4">¡Resultados enviados correctamente!</p>
  )}
  {sendStatus === 'error' && (
    <p className="text-red-500 text-center mt-4">Error al enviar los resultados. Por favor intente nuevamente.</p>
  )}
</form>
          </div>
        )}
      </div>
    </div>
  );
};

export default Results;